import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { isSameDay } from '@repo/date-time';
import ScrollSlider from '../ScrollSlider/ScrollSlider';
import DayOfWeekCell from './DayOfWeekCell';
import { getDaysForWeekCalendar } from './utils/getDaysForWeekCalendar';
export default function WeekRow({ value, initialDate = new Date(), testId, disablePast, minDate, maxDate, flaggedDates, onDateChosen, }) {
    const [initialChild, setInitialChild] = useState(undefined);
    const [rangedDate, setRangedDate] = useState(undefined);
    const days = useMemo(() => {
        return getDaysForWeekCalendar(value, [initialDate, rangedDate], flaggedDates, maxDate, minDate);
    }, [value, initialDate, rangedDate, flaggedDates, maxDate, minDate]);
    useEffect(() => {
        const date = days.find((day) => isSameDay(day.date, initialDate));
        setInitialChild(date?.key ?? undefined);
    }, [initialDate, days]);
    const handleRangeEnd = (onIndex) => {
        setRangedDate(days[onIndex]?.date ?? undefined);
    };
    const handleClick = (id) => {
        const dateChosen = days.find((day) => day.key === id);
        if (!dateChosen)
            return;
        const canSelectDate = (!dateChosen.isInThePast || !disablePast) && !dateChosen.isBeforeMinDate;
        if (!dateChosen.alert && canSelectDate && !dateChosen.isAfterMaxDate) {
            onDateChosen(dateChosen.date);
        }
    };
    return (_jsx(ScrollSlider, { initialChild: initialChild, testId: testId.append('slider'), onClick: handleClick, onRangeEnd: handleRangeEnd, className: "bg-primary", children: days.map((day) => (_jsx(DayOfWeekCell, { day: day, testId: testId.append('day').append(day.key), disablePast: disablePast }, day.key))) }));
}
